<!--
 * @Auther: 罗耀祖
 * @Date: 2022-02-24 09:48:13
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-05-27 15:38:31
 * @name: 定价
 * @Description: 定价
 * @FilePath: \project\src\views\index\afterSale\waitApproveSignAmount\waitApproveSignAmount.vue
 * @Author: desktop
-->
<template>
  <div class="waitApproveSignAmount">
    <div class="container">
      <div class="head">
        <el-button size="mini" type="primary" @click="back">返回</el-button>
      </div>
      <div class="content">
        <div class="row" v-if="has_need_pay">
          <font class="label">是否需要费用</font>
          <div class="value">
            <el-radio-group v-model="need_pay">
              <el-radio
                :label="item.value"
                v-for="item of need_pays"
                :key="item.value"
                >{{ item.label }}</el-radio
              >
            </el-radio-group>
          </div>
        </div>
        <div class="row" v-if="has_pay_user">
          <font class="label">费用收取对象</font>
          <div class="value">
            <el-radio-group v-model="pay_user">
              <el-radio
                :label="item.value"
                v-for="item of pay_users"
                :key="item.value"
                >{{ item.label }}</el-radio
              >
            </el-radio-group>
          </div>
        </div>
        <template v-if="has_fee">
          <div class="part">
            <font class="title">部件</font>
            <div class="fees">
              <template v-for="item of fee">
                <template v-if="item.parent === 'parts_fee'">
                  <div class="fee" :key="item.key" v-if="item.type === 'fee'">
                    <font class="label">{{ item.label }}</font>
                    <el-input
                      class="input"
                      size="mini"
                      v-model="item.value"
                      @blur="
                        () => {
                          !/^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/.test(
                            item.value
                          ) && (item.value = 0);
                        }
                      "
                    ></el-input>
                  </div>
                  <div
                    class="remark"
                    :key="item.key"
                    v-else-if="item.type === 'remark'"
                  >
                    <font class="label">备注</font>
                    <el-input
                      class="textarea"
                      type="textarea"
                      :rows="2"
                      placeholder="请输入备注..."
                      v-model="item.value"
                    ></el-input>
                  </div>
                </template>
              </template>
            </div>
          </div>
          <div class="part">
            <font class="title">工资</font>
            <div class="fees">
              <template v-for="item of fee">
                <template v-if="item.parent === 'salary'">
                  <div class="fee" :key="item.key" v-if="item.type === 'fee'">
                    <font class="label">{{ item.label }}</font>
                    <el-input
                      class="input"
                      size="mini"
                      v-model="item.value"
                      @blur="
                        () => {
                          !/^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/.test(
                            item.value
                          ) && (item.value = 0);
                        }
                      "
                    ></el-input>
                  </div>
                  <div
                    class="remark"
                    :key="item.key"
                    v-else-if="item.type === 'remark'"
                  >
                    <font class="label">备注</font>
                    <el-input
                      class="textarea"
                      type="textarea"
                      :rows="2"
                      placeholder="请输入备注..."
                      v-model="item.value"
                    ></el-input>
                  </div>
                </template>
              </template>
            </div>
          </div>
          <div class="part">
            <font class="title">运费</font>
            <div class="fees">
              <template v-for="item of fee">
                <template v-if="item.parent === 'trans_port'">
                  <div class="fee" :key="item.key" v-if="item.type === 'fee'">
                    <font class="label">{{ item.label }}</font>
                    <el-input
                      class="input"
                      size="mini"
                      v-model="item.value"
                      @blur="
                        () => {
                          !/^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/.test(
                            item.value
                          ) && (item.value = 0);
                        }
                      "
                    ></el-input>
                  </div>
                  <div
                    class="remark"
                    :key="item.key"
                    v-else-if="item.type === 'remark'"
                  >
                    <font class="label">备注</font>
                    <el-input
                      class="textarea"
                      type="textarea"
                      :rows="2"
                      placeholder="请输入备注..."
                      v-model="item.value"
                    ></el-input>
                  </div>
                </template>
              </template>
            </div>
          </div>
          <div class="part">
            <font class="title">其它</font>
            <div class="fees">
              <template v-for="item of fee">
                <template v-if="item.parent === 'others'">
                  <div class="fee" :key="item.key" v-if="item.type === 'fee'">
                    <font class="label">{{ item.label }}</font>
                    <el-input
                      class="input"
                      size="mini"
                      v-model="item.value"
                      @blur="
                        () => {
                          !/^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/.test(
                            item.value
                          ) && (item.value = 0);
                        }
                      "
                    ></el-input>
                  </div>
                  <div
                    class="remark"
                    :key="item.key"
                    v-else-if="item.type === 'remark'"
                  >
                    <font class="label">备注</font>
                    <el-input
                      class="textarea"
                      type="textarea"
                      :rows="2"
                      placeholder="请输入备注..."
                      v-model="item.value"
                    ></el-input>
                  </div>
                </template>
              </template>
            </div>
          </div>
          <div class="sum">
            <font>总计：{{ totalFee }}元</font>
          </div>
        </template>
        <div class="btn-group">
          <!-- <el-button size="mini" @click="unNeedFee">无需金额</el-button> -->
          <el-button size="mini" type="primary" @click="confirm"
            >提交</el-button
          >
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { origin_fee, need_pays, pay_users } from "@/config/issue.config";
import issueService from "@/module/issue/issue.service";
import { confirmation, debounceation } from "@/utils/decorator";
import { getEventBus } from "@/config/eventBus.config.js";
const origin_need_pay = 1;
const origin_pay_user = 1;
export default {
  data() {
    return {
      issueService: new issueService(),
      issue_name: "", //处理方式
      plan_need_pay: 0, //处理方案选择的是否需要费用
      need_pay: 1, //选择的是否需要费用 1是 0否 2暂不填写
      pay_users, //费用收取对象
      pay_user: 1, //选择的费用收取对象
      fee: [], //费用信息
    };
  },
  created() {
    this.getFee();
  },
  computed: {
    // 是否需要费用
    need_pays() {
      return need_pays.filter((x) => x.value !== 2);
    },
    // 费用总计
    totalFee() {
      let fees = this.fee;
      let totalFee = 0;
      for (let x of fees) {
        if (x.type === "fee") {
          totalFee = Number(totalFee) + Number(x.value);
        }
      }
      return totalFee;
    },
    // 存在是否需要费用选择
    has_need_pay() {
      return this.plan_need_pay === 2;
    },
    // 存在费用收取对象
    has_pay_user() {
      return this.issue_name === "货损" && this.need_pay === 1;
    },
    // 存在费用
    has_fee() {
      return this.need_pay === 1 && this.pay_user === 1;
    },
  },
  watch: {
    pay_user: {
      handler(nv, ov) {
        this.fee = JSON.parse(JSON.stringify(origin_fee));
      },
      immediate: false,
      deep: true,
    },
    need_pay: {
      handler(nv, ov) {
        this.pay_user = JSON.parse(JSON.stringify(origin_pay_user));
        this.fee = JSON.parse(JSON.stringify(origin_fee));
      },
      immediate: false,
      deep: true,
    },
  },
  methods: {
    @debounceation(300)
    back() {
      this.$router.go(-1);
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 获取原有费用
     */
    getFee() {
      this.issueService
        .getVeifyQuality({
          issue_id: this.$route.query.issue_id,
          run_id: this.$route.query.run_id,
          run_process_id: this.$route.query.run_process_id,
        })
        .then((res) => {
          let obj = res.data;
          this.issue_name = obj.issue_name;
          this.plan_need_pay = obj.plan.need_pay;
          if (Number(res.data?.plan?.need_pay) !== 0 && res.data?.fee) {
            let fee = JSON.parse(JSON.stringify(origin_fee));
            fee[fee.findIndex((x) => x.key === "shell_fee")].value = Number(
              obj.fee?.parts_fee?.["shell_fee"] ?? ""
            );
            fee[fee.findIndex((x) => x.key === "code_fee")].value = Number(
              obj.fee?.parts_fee?.["code_fee"] ?? ""
            );
            fee[fee.findIndex((x) => x.key === "prellmechanik_fee")].value =
              Number(obj.fee?.parts_fee?.["prellmechanik_fee"] ?? "");
            fee[fee.findIndex((x) => x.key === "keyboard_fee")].value = Number(
              obj.fee?.parts_fee?.["keyboard_fee"] ?? ""
            );
            fee[fee.findIndex((x) => x.key === "hardware")].value = Number(
              obj.fee?.parts_fee?.["hardware"] ?? ""
            );
            fee[fee.findIndex((x) => x.key === "hammer")].value = Number(
              obj.fee?.parts_fee?.["hammer"] ?? ""
            );
            fee[fee.findIndex((x) => x.key === "other")].value = Number(
              obj.fee?.parts_fee?.["other_fee"] ?? ""
            );
            fee[fee.findIndex((x) => x.key === "parts_remark")].value =
              obj.fee?.parts_fee?.["parts_remark"] ?? "";
            fee[fee.findIndex((x) => x.key === "by_the_piece_fee")].value =
              Number(obj.fee?.salary?.["by_the_piece_fee"] ?? "");
            fee[fee.findIndex((x) => x.key === "hourly_wages")].value = Number(
              obj.fee?.salary?.["hourly_wages"] ?? ""
            );
            fee[fee.findIndex((x) => x.key === "oil_paint")].value = Number(
              obj.fee?.salary?.["oil_paint"] ?? ""
            );
            fee[fee.findIndex((x) => x.key === "salary_remark")].value =
              obj.fee?.salary?.["salary_remark"] ?? "";
            fee[
              fee.findIndex((x) => x.key === "amount_returned_by_customer")
            ].value = Number(
              obj.fee?.trans_port?.["amount_returned_by_customer"] ?? ""
            );
            fee[
              fee.findIndex((x) => x.key === "return_customer_amount")
            ].value = Number(
              obj.fee?.trans_port?.["return_customer_amount"] ?? ""
            );
            fee[fee.findIndex((x) => x.key === "transport_remark")].value =
              obj.fee?.trans_port?.["transport_remark"] ?? "";
            fee[fee.findIndex((x) => x.key === "management_expenses")].value =
              Number(obj.fee?.others?.["management_expenses"] ?? "");
            fee[fee.findIndex((x) => x.key === "tax")].value = Number(
              obj.fee?.others?.["tax"] ?? ""
            );
            fee[fee.findIndex((x) => x.key === "others_fee")].value = Number(
              obj.fee?.others?.["others_fee"] ?? ""
            );
            fee[fee.findIndex((x) => x.key === "others_remark")].value =
              obj.fee?.others?.["remark"] ?? "";
            this.fee = fee;
          } else {
            this.fee = JSON.parse(JSON.stringify(origin_fee));
          }
        });
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 无需费用
     */
    // unNeedFee() {
    //   this.$confirm(
    //     "确认金额为0，无需缴费，该操作无法挽回，你还要继续吗？",
    //     "确认金额为0，无需缴费？",
    //     {
    //       confirmButtonText: "确定",
    //       cancelButtonText: "取消",
    //       type: "warning",
    //     }
    //   )
    //     .then(() => {
    //       const fee = JSON.parse(JSON.stringify(origin_fee));
    //       let params = {};
    //       fee.forEach((x) => {
    //         params[x.key] = x.value;
    //       });
    //       this.submit(params);
    //     })
    //     .catch((err) => {});
    // },
    @confirmation("确认提交?")
    confirm() {
      const fee = this.fee;
      let params = {};
      fee.forEach((x) => {
        params[x.key] = x.value;
      });
      this.submit(params);
    },
    @debounceation(300)
    submit(params) {
      let req = {
        issue_id: this.$route.query?.issue_id ?? "",
        run_process_id: this.$route.query?.run_process_id ?? "",
        need_pay: this.need_pay,
        pay_user: this.need_pay ? this.pay_user : origin_pay_user,
        ...params,
      };
      this.issueService.issueFee(req).then((res) => {
        this.$EventBus.$emit(getEventBus("我的售后列表发生变更"));
        this.$router.go(-2);
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.waitApproveSignAmount {
  width: 100%;
  height: 100%;
  overflow-y: auto;
  .container {
    width: 100%;
    box-sizing: border-box;
    padding: 10px;
    .head {
      margin-bottom: 10px;
      @extend .et-flex-start;
    }
    .content {
      width: 100%;
      @extend .et-flex-column-normal;
      .row {
        width: 100%;
        margin: 10px 0;
        padding: 10px 0;
        @extend .et-flex-start;
        font-size: $Vars-font-content-size;
        .label {
          flex-shrink: 0;
          margin-right: 40px;
          text-align: right;
        }
        .value {
          flex: 1;
          @extend .et-flex-normal;
        }
      }
      .part {
        width: 100%;
        padding: 10px 0;
        @extend .et-flex-column-normal;
        .title {
          font-size: $Vars-font-miniTitle-size;
          font-weight: bold;
          color: $Vars-font-important-color;
          padding-bottom: 10px;
        }
        .fees {
          padding: 10px 0;
          width: 100%;
          @extend .et-flex-normal;
          .fee {
            width: 25%;
            box-sizing: border-box;
            padding: 5px 10px;
            @extend .et-flex-start;
            font-size: $Vars-font-content-size;
            .label {
              min-width: calc(#{$Vars-font-content-size} * 4);
              margin-right: 10px;
              text-align: right;
            }
            .input {
              flex: 1;
              /deep/ input {
                text-align: right;
              }
            }
          }
          .remark {
            margin: 10px 0;
            width: 100%;
            box-sizing: border-box;
            padding: 5px 10px;
            @extend .et-flex-normal;
            .label {
              min-width: calc(#{$Vars-font-content-size} * 4);
              margin-right: 10px;
              text-align: right;
            }
            .textarea {
              width: 300px;
            }
          }
        }
      }
      .sum {
        margin: 10px 0;
        width: 100%;
        font-size: $Vars-font-miniTitle-size;
        font-weight: bold;
        color: $Vars-font-important-color;
      }
      .btn-group {
        margin: 20px 0;
        width: 100%;
        @extend .et-flex-center;
      }
    }
  }
}
</style>